export default function transitionFix() {
    $('body').removeClass('preload');
}



// WEBPACK FOOTER //
// ./scripts/common/transition-fix.js